import {Component} from '@angular/core';

import {UIDialogService} from 'app/ui/dialog/dialog.service';

@Component({
    selector: 'request-confirmation',
    templateUrl: 'request-confirmation.component.html',
    styleUrls: ['request-confirmation.component.scss']
})
export class RequestConfirmationComponent {

    constructor(private _dialogService: UIDialogService) {
    }

    public onClose() {
        this._dialogService.close();
    }
}